// Cliente de simulación: usa un Web Worker y, si no existe (pruebas, entornos antiguos), el mismo
// ejecutor en el hilo principal cediendo el control entre tandas.
import type { SimulationProgress } from '@openrocket-web/physics';
import { execute } from './runner';
import type { FromWorker, Outcome, RunRequest, ToWorker } from './protocol';

export interface Running {
  readonly done: Promise<Outcome>;
  cancel(): void;
}

export function startSimulation(request: RunRequest, onProgress: (p: SimulationProgress) => void): Running {
  if (typeof Worker === 'undefined') {
    let cancelled = false;
    const done = execute(request, { onProgress, shouldCancel: () => cancelled, yieldNow: () => new Promise((r) => setTimeout(r, 0)) });
    return { done, cancel: () => void (cancelled = true) };
  }

  const worker = new Worker(new URL('./sim.worker.ts', import.meta.url), { type: 'module' });
  const done = new Promise<Outcome>((resolve) => {
    worker.onmessage = (e: MessageEvent<FromWorker>) => {
      if (e.data.type === 'progress') onProgress(e.data.progress);
      else {
        worker.terminate();
        resolve(e.data.outcome);
      }
    };
    worker.onerror = (e) => {
      worker.terminate();
      resolve({ kind: 'error', message: e.message === '' ? 'Error en el proceso de simulación' : e.message });
    };
  });
  worker.postMessage({ type: 'run', request } satisfies ToWorker);
  return { done, cancel: () => worker.postMessage({ type: 'cancel' } satisfies ToWorker) };
}
